import React from "react";
import Layout from "../../layout";
import Card from "@mui/material/Card";
import Grid from "@mui/material/Grid";
import { Box, Typography } from "@mui/material";
import AdminSensorsTable from "../../components/tables/adminsensors";

const AdminSensorsPage = () => {
    return (
        <Layout pageTitle="Sensors" parentUrl="" parentPageName="">
            <Grid item xs={6}>
                <Card>
                    <Box sx={{ mt: 0.2, textAlign: "end", backgroundColor: "grey.100" }}>
                    </Box>
                    <AdminSensorsTable />
                </Card>
            </Grid>
        </Layout>
    );
};

export default AdminSensorsPage;
